export enum HitType {
  PAGE_VIEW = 'pageview',
  EVENT = 'event',
  TRANSACTION = 'transaction',
  USER_ENGAGEMENT = 'user_engagement',
  FIRST_VISIT = 'first_visit',
  SESSION_START = 'session_start',
}
